<div class="container my-4">
    <div class="row">
      <div class="col-12 ">
        <span class="title_header_bar">School Package</span>
      </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
        <div class="row mt-3 mx-5">
                            
            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Application Number</mat-label>
                    <input matInput  maxlength="25" formControlName="ApplicationNumber"
                        placeholder="Enter Application Number" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-xl-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Product</mat-label>
                    <mat-select class="scrollbarcs" formControlName="ProdudctId" 
                        placeholder="Select the Product ">
                        <mat-select-filter [displayMember]="'value'" [array]="productIdList"
                        (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                        <mat-option *ngFor="let item of filteredList1" [value]="item.id"
                            style="overflow-y: scroll !important;">
                            {{item.productName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            </div>
            <div class="d-flex justify-content-center button-style mt-5">

                <button class="btn btn-secondary mb-3" type="submit" (click)="onsubmit()"
                    matButton>Save</button>
            </div>
</form>
    </div>
    
</div>
